/**
 * Vertical thumbnail rail for PDP thumbnail_left gallery.
 * Shows prev/next only when the rail overflows; no infinite scroll.
 */
if (!customElements.get('pdp-thumb-rail')) {
  customElements.define(
    'pdp-thumb-rail',
    class PdpThumbRail extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-pdp-thumb-rail-scroll]');
        this.prevBtn = this.querySelector('.pdp-thumb-rail__arrow--prev');
        this.nextBtn = this.querySelector('.pdp-thumb-rail__arrow--next');
        if (!this.list || !this.prevBtn || !this.nextBtn) return;

        this.onScroll = this.updateArrows.bind(this);
        this.onResize = this.updateArrows.bind(this);

        this.prevBtn.addEventListener('click', () => this.scrollByPage(-1));
        this.nextBtn.addEventListener('click', () => this.scrollByPage(1));
        this.list.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);

        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.list);

        requestAnimationFrame(() => this.updateArrows());
      }

      disconnectedCallback() {
        this.list?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.resizeObserver?.disconnect();
      }

      scrollByPage(direction) {
        const item = this.list.querySelector('.pdp-thumb-rail__item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.list).gap) || 16;
        const amount = item.offsetHeight + gap;
        this.list.scrollBy({ top: direction * amount, behavior: 'smooth' });
      }

      updateArrows() {
        const { scrollTop, scrollHeight, clientHeight } = this.list;
        const canScroll = scrollHeight > clientHeight + 1;
        const atStart = scrollTop <= 1;
        const atEnd = scrollTop + clientHeight >= scrollHeight - 1;

        this.prevBtn.hidden = !canScroll;
        this.nextBtn.hidden = !canScroll;
        this.prevBtn.disabled = !canScroll || atStart;
        this.nextBtn.disabled = !canScroll || atEnd;
      }
    }
  );
}
